module.exports = __webpack_public_path__ + "static/img/shareable.a31aed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/media/shareable.png
// module id = 616
// module chunks = 1